import { notify } from "../../components/alerts";
import {
  setLoading,
  setNotification,
  setNotifications,
  setNotificationSeen,
  setShow,
  setUpdate,
} from "../../store/slices/notification";
import { AppDispatch } from "../../store/store";
import axiosInstance from "../../utils/axiosInstance";

export const getNotifications = async (
  dispatch: AppDispatch,
  page: number | string = 1,
) => {
  try {
    dispatch(setLoading());
    const response = await axiosInstance.get(
      `/v1/get-notifications?page=${page}`,
    );

    // backend returns pagination under message
    dispatch(setNotifications(response.data.message));
  } catch (error: any) {
    console.log(error?.response?.data);
  } finally {
    dispatch(setLoading());
  }
};

export const getNotification = async (dispatch: AppDispatch, id: string) => {
  dispatch(setShow());

  try {
    dispatch(setLoading());
    const response = await axiosInstance.get(`/v1/get-notification/${id}`);
    // backend returns the data under data
    dispatch(setNotification(response.data.data));
  } catch (error: any) {
    console.log(error?.response?.data);
  } finally {
    dispatch(setLoading());
  }

  dispatch(setShow());
};

export const seenNotification = async (dispatch: AppDispatch, id: string) => {
  try {
    await axiosInstance.patch(`/v1/update-notification/${id}`);
    dispatch(setNotificationSeen(id));
  } catch (error: any) {
    console.log(error?.response?.data);
  }
};

export const update_payment = async (
  dispatch: AppDispatch,
  formData: string,
) => {
  let result = false;
  dispatch(setUpdate());
  try {
    await axiosInstance.post("/verify-payment-request-service", formData);

    notify({ type: "success", message: `We will get back to you shortly.` });
    result = true;
  } catch (err) {
    // logger action
    result = false;
    notify({
      type: "error",
      message: `If you feel something is wrong please email us at account@corporate-setup.com.`,
    });
  }
  dispatch(setUpdate());
  return result;
};

export const update_price = async (dispatch: AppDispatch, formData: string) => {
  let result = false;
  dispatch(setUpdate());
  try {
    await axiosInstance.post("/budget-submitted-request-service", formData);

    notify({ type: "success", message: `We will get back to you shortly.` });
    result = true;
  } catch (err) {
    // logger action
    result = false;
    notify({
      type: "error",
      message: `If you feel something is wrong please email us at account@corporate-setup.com.`,
    });
  }
  dispatch(setUpdate());
  return result;
};
